import React, { useCallback } from 'react'
import { GlobalBox } from 'components/Box/GlobalBox'
import { Grid, Box } from '@mui/material';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
import RegularButton from "components/CustomButtons/Button";
import { useDispatch, useSelector } from "react-redux";
import { postExtendDate, postResetDate } from "redux/actions/configTimePrice/configTimePriceActions"

export const ConfigTimePrice = () => {
    const { rules } = useSelector(({ login }) => login);
    const dispatch = useDispatch();

    const handleExtendDate = useCallback(() => {
        dispatch(postExtendDate())
    }, [dispatch]);

    const handleResetDate = useCallback(() => {
        dispatch(postResetDate())
    }, [dispatch]);

    return (
        <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center", }}>
            <Grid item >
                <GlobalBox title="Configurar precio" icon={<PriceChangeIcon />} >
                    <Box
                        style={{
                            marginTop: 32,
                            display: 'flex',
                            justifyContent: 'center',
                            padding: 16
                        }}
                    >
                        <Grid container spacing={2} >
                            <Grid item xs={12} display="flex" justifyContent="center">
                                <RegularButton
                                    color="info"
                                    disabled={!rules.includes('SUPPORT-PRICES-CHANGE')}
                                    onClick={handleExtendDate}
                                >
                                    Cambiar precio
                                </RegularButton>
                            </Grid>

                            <Grid item xs={12} display="flex" justifyContent="center">
                                <RegularButton
                                    color="success"
                                    onClick={handleResetDate}
                                    disabled={!rules.includes('SUPPORT-PRICES-CHANGE')}
                                >
                                    Regresar precio
                                </RegularButton>
                            </Grid>
                        </Grid>
                    </Box>
                </GlobalBox>
            </Grid>
        </Grid>
    )
}
